import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/index.css'; // Optional: Add your styles here hh

ReactDOM.render(<App />, document.getElementById('root'));
